import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { getKy } from "../services/AbstractService";

import SETTINGS from "../settings.json";

import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import Button from "@mui/material/Button";
import { GoogleLogin } from "@react-oauth/google";
import Stack from "@mui/material/Stack";

import {
  validateGoogleStudentId,
  validateGoogle,
  getUserPriority,
} from "../services/UserService";
import { googleLogout } from "@react-oauth/google";
import { getScoreCategoryLocation } from "../services/ScoreService";
import { doService } from "../services/ServiceHelper";

import { useJwtStorage, useLocalStorage } from "../hooks/useLocalStorage";
import { logoutUser } from "../services/UserService";

import ProgressBar from "../components/ProgressBar";

import { getSubDomain } from "../services/StringService";
import { showError, showSuccess, showPrompt } from "../components/ATPDialogs";
import {
  getFirstSchool,
  getSchoolBySubdomain,
  getSchoolByEid,
  getEmptySchool,
} from "../services/SchoolService";
import { createKioskTardy } from "../services/ScoreService";
import { isStringEmpty } from "../services/StringService";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";

const GOOGLE_WEB_CLIENT_ID =
  "55954634468-jp58t37klj69rr0l1vljnsmmg6d0pltm.apps.googleusercontent.com";

const TardyLoginLocation = ({ isStudentLogin = false }) => {
  const [_school, setSchool] = useLocalStorage(
    "Auth",
    "school",
    getEmptySchool()
  );
  const [, setUser] = useLocalStorage("Auth", "user", {});
  const [_jwt, setJwt] = useJwtStorage();

  const [showProgress, setShowProgress] = useState(false);

  const params = useParams();
  const [_receiptUrl, setReceiptUrl] = useState("");
  const [queryParams] = useSearchParams();
  const [_parentSourceId, setParentSourceId] = useState("");
  const [_scoreCategoryLocation, setScoreCategoryLocation] = useState({});

  let _hasInit = false;

  useEffect(() => {
    const subdomain = getSubDomain();
    let school = getSchoolBySubdomain(subdomain);

    if (!_hasInit) {
      sessionStorage.setItem("ATP.version", SETTINGS.version);
      _hasInit = true;
      if (school != null && school.lambdaEndpoint != null) {
        setSchool(school);
      } else {
        school = getEmptySchool();
        setSchool(school);
      }

      initScoreCategoryLocation(school);

      // 5 minutes
      // 3000000
      setInterval(checkVersion, 300000);
    }

    if (!isStringEmpty(queryParams.get("id"))) {
      setParentSourceId(queryParams.get("id"));
    }
  }, [params]);

  const initScoreCategoryLocation = (school) => {
    setShowProgress(true);
    console.log(school);
    doService(
      getScoreCategoryLocation(school, _jwt, queryParams.get("locationEid")),
      (result) => {
        setScoreCategoryLocation(result.data);
        setShowProgress(false);
      }
    );
  };

  async function checkVersion() {
    getKy(null).get("data/settings.json").json().then((response) => {
      const currentVersion = sessionStorage.getItem("ATP.version");
      if (currentVersion != null) {
        if (currentVersion !== response.version) {
          window.location.reload();
          console.log("CLICK OK TO UPGRADE");
        }
      }
    });
  }
  const myStyle = {
    backgroundImage: "url('image/bg2.jpg')",
    height: "100vh",
    backgroundSize: "cover",
  };

  const postLogin = (school, jwt, user) => {
    // wait for school settings to apply
    setTimeout(function () {
      // console.log("sleep 100");
      setUser(user);
      setJwt(jwt);

      evalWelcome(jwt);
    }, 100);
  };

  const handleValidateGoogle = async (googleJwt) => {
    setShowProgress(true);

    let school = _school;
    if (_school == null) {
      // get first school (for URL) and set it
      school = getFirstSchool();
      setSchool(school);
    }

    // prompt user for digits
    if (isStudentLogin === false) {
      showPrompt(
        "Enter the Last 4 Digits of your Student ID.",
        "",
        "",
        (results) => {
          console.log(results);
          doValidateGoogleStudentId(school, googleJwt, results);
        }
      );
    } else {
      doValidateGoogle(school, googleJwt);
    }
  };

  const isNativeGoogleSigninAvailable = () => {
    return (
      typeof window !== "undefined" &&
      !!window.Capacitor?.isNativePlatform?.()
    );
  };

  const waitForNativeAuthBridge = async (timeoutMs = 6000) => {
    const startedAt = Date.now();

    while (Date.now() - startedAt < timeoutMs) {
      if (typeof window.AllTimelyAuthBridge?.signInWithGoogle === "function") {
        return window.AllTimelyAuthBridge;
      }

      await new Promise((resolve) => setTimeout(resolve, 150));
    }

    return null;
  };

  const handleNativeGoogleSignin = async () => {
    try {
      const authBridge = await waitForNativeAuthBridge();
      if (!authBridge || typeof authBridge.signInWithGoogle !== "function") {
        showError(
          "Unable to Log In",
          "Native Google Sign-In bridge was not ready. Please close and reopen the app.",
        );
        setShowProgress(false);
        return;
      }

      setShowProgress(true);

      const googleJwt = await authBridge.signInWithGoogle({
        // Native Google Sign-In must request ID token with the web/server OAuth client ID.
        clientId: GOOGLE_WEB_CLIENT_ID,
      });

      if (isStringEmpty(googleJwt)) {
        throw new Error("Native Google Sign-In returned no idToken");
      }

      handleValidateGoogle(googleJwt);
    } catch (error) {
      console.log(error);
      setShowProgress(false);
      showError(
        "Unable to Log In",
        error?.message || "Google sign-in failed. Please try again.",
      );
    }
  };

  const doValidateGoogle = (school, googleJwt) => {
    // console.log(school);
    validateGoogle(school, googleJwt)
      .then(async (result) => {
        if (result.detail) {
          showError("Unable to Log In", "User does not exist in AllTimely.");
          return;
        }

        const jwt = result.data.jwt;
        const user = result.data.user;

        if (getUserPriority(jwt) !== 500) {
          showError("Unable to Create Tardy", "User is not a Student.");
          return;
        }

        school = getSchoolByEid(result.data.schools[0].schoolEid);
        setSchool(school);
        doPostLogin(school, jwt, user);
      })
      .catch((error) => {
        showError("Unable to validate user.  Please login again.");
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const doValidateGoogleStudentId = (school, googleJwt, studentId) => {
    validateGoogleStudentId(school, googleJwt, studentId)
      .then(async (result) => {
        if (result.detail) {
          showError("Unable to Log In", result.detail);
          return;
        }

        // see list of schools; assign school
        const jwt = result.data.jwt;
        const user = result.data.user;

        if (getUserPriority(jwt) !== 500) {
          showError("Unable to Create Tardy", "User is not a Student.");
          return;
        }

        school = getSchoolByEid(result.data.schools[0].schoolEid);
        setSchool(school);
        doPostLogin(school, jwt, user);
      })
      .catch((error) => {
        showError("Unable to validate user.  Please login again.");
      })
      .finally(() => {
        setShowProgress(false);
      });
  };

  const doPostLogin = (school, jwt, user) => {
    // NEVER DELETE - USED FOR ANDROID
    console.log(
      "NXT:" + SETTINGS.version + "|" + jwt + "|" + school.lambdaEndpoint
    );
    postLogin(school, jwt, user);
  };

  // const evalScoreTardyQr = (jwt) => {
  //   const qrDetails = decryptTardy(SCORE_QR_KEY, qrCode);

  // };

  const evalWelcome = (jwt) => {
    // if 100 then print queue not needed
    let sourceStatus = 100;
    if (isStudentLogin === true) {
      // student logging in via qr - then prompt kiosk to print
      sourceStatus = 0;
    }

    let sourceId = "";

    if (!isStringEmpty(_parentSourceId)) {
      sourceId = _parentSourceId;
    }

    doService(
      createKioskTardy(_school, jwt, sourceId, sourceStatus, queryParams.get("locationEid")),
      (results) => {
        showSuccess("Tardy Processed", "Tardy has been added.", () => {
          const url = `/#/score/receipt/${results.data.join(",")}`;
          setReceiptUrl(url);

          setTimeout(function () {
            // if logging in via the kiosk, the click button to get to print page
            // if (isStudentLogin === false) {
            //   document.getElementById("rl").click();
            // }

            setTimeout(function () {
              logoutUser();
              googleLogout();
            }, 3000);
          }, 300);
        });
        return;
      },
      (detail) => {
        showError("Unable to Process Tardy", detail, () => {
          logoutUser();
          googleLogout();
        });
        return;
      }
    );
  };

  return (
    <Container maxWidth="lg" sx={myStyle}>
      <br />
      <br />
      <img
        src="image/icon-student-46.0.png"
        className="tlm-img-center"
        style={{ border: "2px white solid" }}
        alt="site icon"
      />

      <div className="tlm-div-center">
        <Table>
          <TableBody>
            <ProgressBar showProgress={showProgress} />

            <TableRow>
              <TableCell style={{ textAlign: "center", border: "none" }}>
                {_scoreCategoryLocation.catName == null && (
                  <span
                    className="bebas-neue-regular"
                    style={{ fontSize: "40px", color: "#ffffff" }}
                  >
                    Tardy QR Login
                  </span>
                )}
                {_scoreCategoryLocation.catName != null && (
                  <>
                    <span
                      className="bebas-neue-regular"
                      style={{ fontSize: "40px", color: "#ffffff" }}
                    >
                      QR Login for {_scoreCategoryLocation.catName}
                      <br />
                    </span>
                    <span
                      className="bebas-neue-regular"
                      style={{ fontSize: "30px", color: "#ffffff" }}
                    >
                      at {_scoreCategoryLocation.locationName}
                    </span>
                      
                  </>
                )}
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ border: "none" }}>
                <div
                  className="tlm-label-center"
                  style={{ marginBottom: "10px" }}
                >
                  SIGN IN WITH:
                </div>

                <Stack
                  direction="row"
                  spacing={5}
                  alignItems="center"
                  justifyContent="center"
                  sx={{ mt: 2 }}
                >
                  {isNativeGoogleSigninAvailable() ? (
                    <Button
                      variant="contained"
                      size="large"
                      onClick={handleNativeGoogleSignin}
                    >
                      SIGN IN WITH GOOGLE
                    </Button>
                  ) : (
                    <GoogleLogin
                      onSuccess={(credentialResponse) => {
                        handleValidateGoogle(credentialResponse.credential);
                      }}
                      onError={() => {
                        console.log("Login Failed");
                      }}
                      size="large"
                      type="standard"
                      theme="filled_blue"
                      logo_alignment="left"
                    />
                  )}
                </Stack>
              </TableCell>
            </TableRow>

            <TableRow>
              <TableCell sx={{ border: "none" }}>
                <div className="tlm-label-center" style={{ marginTop: "10px" }}>
                  Copyright 2026. The Local Machine, LLC
                </div>
                <div className="tlm-label-center" style={{ marginTop: "10px" }}>
                  <Link
                    href="https://www.alltimely.com"
                    target="_blank"
                    sx={{
                      ml: 0.5,
                      mr: 0.5,
                      color: "#c0c0c0",
                    }}
                  >
                    www.alltimely.com
                  </Link>
                </div>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
        <Link target="_blank" href={_receiptUrl} id="rl" />
      </div>
    </Container>
  );
};

export default TardyLoginLocation;
